import { Injectable, computed, inject, signal } from '@angular/core';

import type { AuthSession, AuthenticatedUser } from '@domain/models/auth.model';
import { isSessionExpired } from '@domain/models/auth.model';
import { AuthRepository } from '@domain/repositories/auth.repository';

@Injectable({ providedIn: 'root' })
export class AuthSessionStore {
  private readonly authRepository = inject(AuthRepository);

  private readonly sessionSignal = signal<AuthSession | null>(this.authRepository.restoreSession());

  readonly session = this.sessionSignal.asReadonly();
  readonly user = computed<AuthenticatedUser | null>(() => this.sessionSignal()?.user ?? null);
  readonly isAuthenticated = computed(() => {
    const session = this.sessionSignal();
    return !!session && !isSessionExpired(session);
  });
  readonly accessToken = computed(() => this.sessionSignal()?.accessToken ?? null);

  setSession(session: AuthSession): void {
    this.authRepository.persistSession(session);
    this.sessionSignal.set(session);
  }

  clear(): void {
    this.authRepository.clearSession();
    this.sessionSignal.set(null);
  }
}
